import React from 'react';
import ReactDOM from 'react-dom';
import UserNav from './components/user-nav'


document.querySelectorAll('#gc-usernav').forEach(domContainer => {
   ReactDOM.render(
    <React.StrictMode>
      <UserNav/>
    </React.StrictMode>,
    domContainer
  );

});

